/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
    getPAFAA070detail,
    getPAFAA070detailbs,
    getPAJAC020CodeListPublic,
    getPAJAC020TaskManager,
} from '../../../services/Api';

import PopupSendMail from '../../../shared/components/PopupSendMail';
import RecruitPage from '../../../shared/components/RecruitPage';
import { BIZ_TYPE_OPTIONS } from '../../../shared/constants/app';
import { decodeToken, getCodeName } from '../../../utils';
import PAEAA060 from '../PAEAA010/popupPAEAA060';
const PAEAA070 = () => {
    const printRef = useRef();
    const navigate = useNavigate();
    const { id } = useParams();
    const [data, setData] = useState({});
    const [popupData, setPopupData] = useState(null);
    const [location, setLocation] = useState({});
    const [recruitTime, setRecruitTime] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isPopupSendMailOpen, setIsPopupSendMailOpen] = useState(false);
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const [companyType, setCompanyType] = useState('');
    const [searchParams] = useSearchParams();
    const bs = searchParams.get('bs');
    const [receiver, setReceiver] = useState({ id: '', name: '' });
    const codeLists = {
        A11: [],
        A12: [],
        A14: [],
        A46: [],
    };

    const fetchData = useCallback(async () => {
        try {
            await getPAJAC020TaskManager().then((res) => (codeLists.A11 = res.data));
            await getPAJAC020CodeListPublic('A14,A12,A46').then((res) => {
                const codeListData = res.data;
                codeLists.A12 = codeListData.A12;
                codeLists.A14 = codeListData.A14;
                codeLists.A46 = codeListData.A46;
            });
            const response =
                bs === null || bs === undefined ? await getPAFAA070detail(id) : await getPAFAA070detailbs(id, bs);
            const data = response.data;

            setData({
                ...data,
                recruitClass: getCodeName(data.recruitClass, 'A11', codeLists),
                recruitForm: getCodeName(data.recruitForm, 'A12', codeLists),
                recruitLicense: getCodeName(data.recruitLicense, 'A14', codeLists),
                needPaper: getCodeName(data.needPaper, 'A46', codeLists),
            });
            setLocation({
                pointX: data.pointX,
                pointY: data.pointY,
            });
            setRecruitTime(data.recruitTime);
            if (data.companyType !== null) {
                const bizType = BIZ_TYPE_OPTIONS.find((item) => item.code === data.companyType);

                setCompanyType(bizType?.codeName);
            }
            if (data.recruitClass) {
            }
        } catch (error) {
            console.error(error);
        }
        // eslint-disable-next-line
    }, [id]);

    const openPopup = () => {
        if (decode?.authorities === 'ROLE_P') {
            setPopupData((prev) => ({
                ...prev,
                ...data,
                recruitSeq: data.seq,
            }));
            setIsPopupOpen(true);
        } else if (decode?.authorities === 'ROLE_C') {
            window.alert('개인회원만 이용가능합니다.');
        } else {
            window.alert('로그인 후 이용가능합니다.');
        }
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupData(null);
        setIsPopupSendMailOpen(false);
    };

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            <div id="content">
                <div className="container">
                    <div id="job-detail" ref={printRef}>
                        {/* Top Detail */}
                        <div id="summary-job">
                            <div className="rsm-mng__btbx rsm-mng__btbx3 mb10">
                                <div className="nav-job">
                                    <h1>채용정보</h1>
                                </div>
                                {/* <button
                                    type="button"
                                    className="rsm-mng__btn"
                                    onClick={() => {
                                        navigate('/paeaa010');
                                    }}
                                >
                                    목록
                                </button> */}
                            </div>
                            <RecruitPage
                                data={data}
                                fetchData={fetchData}
                                decode={decode}
                                id={id}
                                setIsPopupSendMailOpen={setIsPopupSendMailOpen}
                                isPopupSendMailOpen={isPopupSendMailOpen}
                                printRef={printRef}
                                openPopup={openPopup}
                                setReceiver={setReceiver}
                                companyType={companyType}
                                recruitTime={recruitTime}
                                location={location}
                            />
                        </div>
                        {/* End Top Detail */}
                    </div>
                </div>
            </div>
            {isPopupOpen && <PAEAA060 popupData={popupData} closePopup={closePopup} />}
            {isPopupSendMailOpen && <PopupSendMail closePopup={closePopup} receiver={receiver} />}
        </>
    );
};

export default PAEAA070;
